import { useCallback, useEffect, useState } from 'react';
import { useAdminApi, ApiError } from '../../../Admin/shared/adminApi';
import type { UserReferralsDetail } from './types';

export interface UserReferralsFilters {
  from?: string;
  to?: string;
}

export function useUserReferrals(userId: string | null, filters: UserReferralsFilters) {
  const { request } = useAdminApi();
  const [data, setData] = useState<UserReferralsDetail | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(true);

  const load = useCallback(async () => {
    if (!userId) {
      setData(null);
      setLoading(false);
      return;
    }

    setLoading(true);
    setError(null);
    try {
      setData(
        await request<UserReferralsDetail>({
          env: 'prod',
          path: `/admin/analytics/referrals/users/${userId}`,
          query: filters as Record<string, string | number | undefined>,
        }),
      );
    } catch (e) {
      setError(e instanceof ApiError ? e.message : 'Failed to load user referrals');
      setData(null);
    } finally {
      setLoading(false);
    }
  }, [request, userId, JSON.stringify(filters)]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    void load();
  }, [load]);

  return { data, error, loading, reload: load };
}
